/**
 * @ngdoc directive
 * @name formradio
 *
 * @description
 * Radio button layout component
 */
module.directive('formRadio', function($timeout) {
  'use strict';
  return {
    restrict: 'EA',
    require: '^ngModel',
    replace: true,
    transclude: true,
    scope: {
      model: '=ngModel',
      groupName: '@?',
      name: '@',
      subClass: '@?',
      readonly: '=?',
      labels: '='
    },
    link: function($scope, element, attrs, ctrl) {
      $scope.isRequired = !!attrs.isRequired;
    },
    template:
      '<p class="aqua-form--radios">' +
        '  <span class="aqua-form--label" ng-transclude></span>' +
        '  <span class="aqua-form--radios--input {{subClass}}">' +
        '    <label class="aqua-form--radio " ' +
        '      ng-repeat="label in labels" ' +
        '      ng-class="{\'is-active\': model[name] === label.value}">' +
        '      <span class="aqua-form--radio--input">' +
        '        <input type="radio" name="{{groupName || name}}" class="aqua-form--radio--input--box" ng-model="model[name]" ng-value="label.value" ng-required="isRequired" ng-disabled="readonly">' +
        '      </span>' +
        '      <span class="aqua-form--radio--label">{{label.text}}</span>' +
        '    </label>' +
        '  </span>' +
        '</p>'
  };
});
